import { render, staticRenderFns } from "./ReplyDocumentPreview.vue?vue&type=template&id=cc0f92b6&"
import script from "./ReplyDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./ReplyDocumentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports